import { QRCODE } from "../../actions";



const qrCodeListReducer = (state = [], action) => {
    switch (action.type) {
        case QRCODE.CLEAR_QRCODE_LIST:
            return [];
        case QRCODE.SET_QRCODE_LIST:
            return [...action?.qrCodeList];
        default:
            return state;
    }
}

export default qrCodeListReducer